<template>
  <div class="topbar-item">
    <div
      class="
        btn btn-icon
        w-auto
        btn-clean
        d-flex
        align-items-center
        btn-lg
        px-2
      "
      id="kt_quick_user_toggle"
    >
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-4
          user-name
        "
        >{{
          currentUser.role == "admin"
            ? "Admin"
            : currentUser.first_name + " " + currentUser.last_name
        }}</span
      >
      <v-avatar size="35">
        <img
          id="header_profile_img"
          :src="
            currentUser.profile_photo_path
              ? currentUser.profile_photo_path
              : 'media/users/default.jpg'
          "
        />
      </v-avatar>
      <!--      <b-avatar v-else></b-avatar>-->
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-5
        "
      >
        <h3 class="font-weight-bold m-0 user-name">
          {{
            currentUser.role == "admin"
              ? "Admin"
              : currentUser.first_name + " " + currentUser.last_name
          }}
          <br /><small class="text-left user-role-text">{{
            currentUser.role == "producer" ? "Händler" : currentUser.role
          }}</small>
        </h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <div class="navi navi-spacer-x-0 p-0">
          <!-- <router-link
            :to="'/dealer/edit-profile/' + userId"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
            v-if="userRole == 'producer'"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <b-icon
                      icon="person"
                      aria-hidden="true"
                    ></b-icon>
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Profil bearbeiten</div>
                <div class="text-muted">Profildetails verwalten</div>
              </div>
            </div>
          </router-link> -->
          <router-link
            :to="'/dealer/change-password/' + currentUser.id"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
            v-if="currentUser.role == 'producer'"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <b-icon icon="lock" aria-hidden="true"></b-icon>
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Password ändern</div>
                <div class="text-muted">
                  Sichern sie ihr Profil mit einem Passwort
                </div>
              </div>
            </div>
          </router-link>
          <router-link
            :to="'/admin/change-password/' + currentUser.id"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
            v-if="currentUser.role == 'admin'"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <b-icon icon="lock" aria-hidden="true"></b-icon>
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Password ändern</div>
                <div class="text-muted">
                  Sichern sie ihr Profil mit einem Passwort
                </div>
              </div>
            </div>
          </router-link>
          <!-- <router-link
            :to="'/dealer/support'"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
            v-if="currentUser.role == 'producer'"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <b-icon icon="exclamation-circle" aria-hidden="true"></b-icon>
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Support</div>
                <div class="text-muted">Send your queries to us</div>
              </div>
            </div>
          </router-link> -->
          <a @click="onLogout" class="navi-item logout-btn">
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-warning">
                    <b-icon icon="power" aria-hidden="true"></b-icon>
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Abmelden</div>
              </div>
            </div>
          </a>
        </div>
        <div class="separator separator-dashed my-7"></div>
      </perfect-scrollbar>
    </div>

    <v-dialog v-model="showModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen sie sich wirklich abmelden?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn class="no-button" @click="showModal = false"> Nein </v-btn>
          <v-btn @click="logout" class="yes-button"> Ja </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}

.logout-btn {
  cursor: pointer;
}

.user-name {
  text-transform: capitalize;
}

.user-role-text {
  font-size: 13px;
}

.profile-img {
  width: 2.5em;
  height: 2.5em;
  border-radius: 50% !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import { LOGOUT, EMPTY_CART } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import HtmlClass from "@/core/services/htmlclass.service";
import store from "@/core/services/store";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "KTQuickUser",
  data() {
    return {
      userRole: null,
      userName: "",
      showModal: false,
      userId: "",
      profileImg: "",
      user: store.getters.currentUser,
      defaultProfileURL: window.location.origin + "/media/users/default.jpg",
    };
  },
  mounted() {
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    this.userRole = localStorage.getItem("bar_book_a_room_user_access_role");
    this.userId = localStorage.getItem("bar_book_a_room_user_access_id");
    this.profileImg = localStorage.getItem(
      "bar_book_a_room_user_profile_picture"
    );
  },
  methods: {
    onLogout() {
      this.showModal = true;
    },
    logout() {
     
      let currenThis = this
      this.showModal = false;
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.$store.dispatch(EMPTY_CART, []);
      localStorage.removeItem("userCheckoutDetails");
      localStorage.removeItem("dealer_order_count");
      this.$store.dispatch(LOGOUT).then(() => {
        setTimeout(() => {
          currenThis.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          currenThis.$router.go();
        }, 2000);
      });
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
  },
  computed: {
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>
